import { memo, type ReactNode } from 'react';

export type ShareLinkModalFooterProps = {
  children: ReactNode;
};

/**
 * Pinned footer for `ShareLinkModal`. Callers render this as the last child of the modal so it
 * stays fixed below the scrollable body.
 */
export const ShareLinkModalFooter = memo(({ children }: ShareLinkModalFooterProps) => {
  return <div className="shrink-0 border-t ads:border-t-default border-t-gray-4 px-6 py-3">{children}</div>;
});

ShareLinkModalFooter.displayName = 'ShareLinkModalFooter';
